import { Injectable, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ComponentType } from '@angular/cdk/overlay/index';
import { MatDialogConfig } from '@angular/material/dialog';
import { UbiDialogComponent } from 'uber-ui';

@Injectable()
export class DialogService {

  private ref: any;
  private fn: Function;
  public response: Observable<any>;
  constructor() { }

  setDialog(fn: Function) {
    this.ref = fn();
    this.fn = fn;
    this.response = this.ref.dialog.onResponse();
  }

  getDialogRef(): UbiDialogComponent {
    return this.fn().dialog;
  }

  /**
   * To Show alert dialog
   * @param message Message content
   * @param title Dialog title
   */
  alert(message: string, title: string = ''): Observable<'submit' | 'close'> {
    this.ref.setData({ title, message, type: 'alert' });
    this.ref.dialog.show();
    return this.response.pipe(take(1));
  }

  /**
   * To Show confirm dialog
   * @param message Message content
   * @param title Dialog title
   */
  // tslint:disable-next-line:max-line-length
  confirm(message: string, title: string = '', autoFocus: boolean = true, disableClose: boolean = false): Observable<'submit' | 'close' | any> {
    this.ref.setData({ title, message, type: 'confirm' });
    this.ref.dialog.show(null, {
      autoFocus: autoFocus,
      disableClose: disableClose
    });
    return this.response.pipe(take(1));
  }

  show(componentRef?: ComponentType<any> | TemplateRef<any>, matConfig?: MatDialogConfig): Observable<'submit' | 'close' | any> {
    this.ref.dialog.show(componentRef, matConfig);
    return this.response.pipe(take(1));
  }
}
